module.exports = __webpack_public_path__ + "static/img/spmp-2.9c8dffc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spmp/spmp-2.jpg
// module id = UGne
// module chunks = 1